import http from "./http.js";

/**
 * 获取影片列表
 */
export function getFilmList(params) {
  return http.postRequestToken("/uc/filmExhibition/queryList", params);
}

/**
 * 获取影片场次详情
 */
export function getFilmDetail(id) {
  return http.postRequestToken("/uc/filmExhibition/sessionsDetail", { id });
}

/**
 * 创投嘉宾预约
 */
export function orderSession(sessionsId) {
  return http.postRequestToken("/uc/filmExhibition/orderSessions", { sessionsId });
}

/**
 * 创投嘉宾取消预约
 */
export function cancelOrder(orderId) {
  return http.postRequestToken("/uc/filmExhibition/cancelOrderSessions", { orderId });
}

/**
 * 获取嘉宾个人预约列表
 */
export function getOrderList(params) {
  return http.postRequestToken("/uc/filmExhibition/orderUserList", params);
}
  